import React, { useEffect, useRef, useState } from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import TBody from "../../common/table/tBody";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import Td from "../../common/table/td";
import Button from "../../common/button/button";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import NumberFormat from "react-number-format";

export function ModalSimularFaturaPendentePrevisorCustos(props) {
    const mesesPendentePrevisorCustos = props.mesesPendentePrevisorCustos || [];
    const [detalheCalculoMedia, setDetalheCalculoMedia] = useState(null);
    const [mesesEdicao, setMesesEdicao] = useState([]);
    const [modoRevisao, setModoRevisao] = useState(false);
    const [mensagemRevisao, setMensagemRevisao] = useState("");
    const [exibirAvisoPendenciasManuais, setExibirAvisoPendenciasManuais] = useState(false);
    const refsMeses = useRef({});

    useEffect(() => {
        setMesesEdicao(clonarMesesPendentePrevisorCustos(mesesPendentePrevisorCustos));
        setModoRevisao(false);
        setMensagemRevisao("");
        setExibirAvisoPendenciasManuais(false);
    }, [props.mesesPendentePrevisorCustos]);

    useEffect(() => {
        if (!props.competenciaFoco || !mesesEdicao.length) return;

        const chaveCompetencia = getChaveCompetencia(props.competenciaFoco);
        setTimeout(() => {
            if (refsMeses.current[chaveCompetencia]) {
                refsMeses.current[chaveCompetencia].scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100);
    }, [props.competenciaFoco, mesesEdicao]);

    function clonarMesesPendentePrevisorCustos(meses) {
        return (meses || []).map((mes) => ({
            ...mes,
            ucs_importacao: (mes.ucs_importacao || []).map((uc) => ({
                ...uc,
                importada_inicial: !!uc.importada,
                valor_preenchido_media: !!uc.valor_preenchido_media,
                historico_anos_anteriores: [...(uc.historico_anos_anteriores || [])],
            })),
        }));
    }

    function existeUcPendente(meses) {
        return (meses || []).some((mesPendente) => (mesPendente.ucs_importacao || []).some((uc) => !uc.importada));
    }

    function aplicarMediaPendentes() {
        const mesesComMediaAplicada = mesesEdicao.map((mesPendente) => ({
            ...mesPendente,
            ucs_importacao: (mesPendente.ucs_importacao || []).map((uc) =>
                uc.importada
                    ? uc
                    : {
                          ...uc,
                          importada: parseFloat(uc.media_historico_anos_anteriores || 0) > 0,
                          valor: parseFloat(uc.media_historico_anos_anteriores || 0),
                          valor_preenchido_media: parseFloat(uc.media_historico_anos_anteriores || 0) > 0,
                      }
            ),
        }));

        setMesesEdicao(mesesComMediaAplicada);
        setModoRevisao(true);
        if (existeUcPendente(mesesComMediaAplicada)) {
            setExibirAvisoPendenciasManuais(true);
            setMensagemRevisao("Revise os meses abaixo. Os valores preenchidos serão salvos, e as pendências restantes poderão ser preenchidas depois.");
            return;
        }
        setExibirAvisoPendenciasManuais(false);
        setMensagemRevisao("Revise todos os meses abaixo. As UCs pendentes foram preenchidas com a media dos anos anteriores. Confirme para aplicar na tabela principal.");
    }

    function confirmarMediaPendentes() {
        props.onAplicarMediaPendentes(mesesEdicao || []);
    }

    function cancelarMediaPendentes() {
        setMesesEdicao(clonarMesesPendentePrevisorCustos(mesesPendentePrevisorCustos));
        setModoRevisao(false);
        setMensagemRevisao("");
        setExibirAvisoPendenciasManuais(false);
    }

    function atualizarValorUc(indiceMes, indiceUc, valorDigitado) {
        const valorNumerico = parseFloat(valorDigitado) || 0;

        const mesesAtualizados = (mesesEdicao || []).map((mes, iMes) =>
            iMes !== indiceMes
                ? mes
                : {
                      ...mes,
                      ucs_importacao: (mes.ucs_importacao || []).map((uc, iUc) =>
                          iUc !== indiceUc
                              ? uc
                              : {
                                    ...uc,
                                    valor: valorNumerico,
                                    importada: valorNumerico > 0,
                                    valor_preenchido_media: false,
                                }
                      ),
                  }
        );

        setMesesEdicao(mesesAtualizados);
        setModoRevisao(true);
        if (existeUcPendente(mesesAtualizados)) {
            setExibirAvisoPendenciasManuais(true);
            setMensagemRevisao("Revise os meses abaixo. Os valores preenchidos serão salvos, e as pendências restantes poderão ser preenchidas depois.");
            return;
        }
        setExibirAvisoPendenciasManuais(false);
        setMensagemRevisao("Revise todos os meses abaixo. Os valores alterados serao aplicados na tabela principal somente apos confirmar.");
    }

    function formatarCompetencia(item) {
        return `${String(item.mes).padStart(2, "0")}/${item.ano}`;
    }

    function getChaveCompetencia(item) {
        return `${item.ano}-${String(item.mes).padStart(2, "0")}`;
    }

    return (
        <>
            <ModalAlert titulo="Unidades com Importação Pendente" handleClose={props.handleClose} maxWidth={900}>
                {modoRevisao ? (
                    <div style={{ display: "flex", flexDirection: "column", rowGap: 8 }}>
                        <div style={{ color: "#00a04d", fontWeight: 600 }}>{mensagemRevisao}</div>
                        <Row>
                            <Grid cols="12 6 6 6">
                                <Button text="Salvar" type="success" event={confirmarMediaPendentes} />
                            </Grid>
                            <Grid cols="12 6 6 6">
                                <Button text="Cancelar" type="danger" event={cancelarMediaPendentes} />
                            </Grid>
                        </Row>
                    </div>
                ) : (
                    <div style={{ paddingTop: 20 }}>
                        <Row>
                            <Grid cols="12 6 6 6">
                                <Button
                                    style={{ margin: 0 }}
                                    solid={true}
                                    text="Aplicar média em todas UCs com importação pendente"
                                    type="primary"
                                    event={aplicarMediaPendentes}
                                />
                            </Grid>
                        </Row>
                        {exibirAvisoPendenciasManuais ? (
                            <div style={{ color: "#d32f2f", fontWeight: 600, marginTop: 8 }}>Ainda existem meses sem dados historico para alguma das UCs. Informe os valores manualmente.</div>
                        ) : null}
                    </div>
                )}
                <div style={{ height: "400px", overflowY: "auto", marginTop: 20 }}>
                    <div style={{ display: "grid", rowGap: 12 }}>
                        {mesesEdicao.map((mesPendente, indiceMes) => (
                            <div
                                key={`${mesPendente.ano}-${mesPendente.mes}-${indiceMes}`}
                                ref={(ref) => {
                                    refsMeses.current[getChaveCompetencia(mesPendente)] = ref;
                                }}
                                style={{
                                    border: "1px solid #d7dbe3",
                                    borderRadius: 6,
                                    overflow: "hidden",
                                    backgroundColor: "#fff",
                                }}
                            >
                                <div
                                    style={{
                                        padding: "8px 10px",
                                        backgroundColor: "#30303d",
                                        color: "#fff",
                                        fontWeight: 700,
                                    }}
                                >
                                    Competência: {formatarCompetencia(mesPendente)}
                                </div>
                                <Table responsive maxHeight="360px">
                                    <THead>
                                        <Tr>
                                            <Th style={{ fontSize: "0.8rem" }}>Unidade Consumidora</Th>
                                            <Th style={{ fontSize: "0.8rem" }} width={100}>
                                                Status
                                            </Th>
                                            <Th style={{ fontSize: "0.8rem" }} width={100}>
                                                Valor
                                            </Th>
                                            <Th style={{ fontSize: "0.8rem" }} colSpan={2} width={200}>
                                                Média anos anteriores
                                            </Th>
                                        </Tr>
                                    </THead>
                                    <TBody>
                                        {(mesPendente.ucs_importacao || []).map((uc, indiceUc) => (
                                            <Tr
                                                key={`${mesPendente.ano}-${mesPendente.mes}-${indiceUc}`}
                                                style={{ backgroundColor: uc.valor_preenchido_media ? "#EEE" : "#FFF" }}
                                            >
                                                <Td fontSize="0.8rem">{uc.nome_unidade_consumidora}</Td>
                                                <Td fontSize="0.8rem" color={uc.importada ? "#28a745" : "#ef5350"} fontWeight={700}>
                                                    {uc.importada ? "Importada" : "Pendente"}
                                                </Td>
                                                <Td fontSize="0.8rem">
                                                    {uc.importada_inicial ? (
                                                        <span>R$ {adicionarPontosMilhar(parseFloat(uc.valor || 0).toFixed(2))}</span>
                                                    ) : (
                                                        <NumberFormat
                                                            className="form-control"
                                                            disabled={!!uc.valor_preenchido_media}
                                                            placeholder={"0,00"}
                                                            decimalSeparator={","}
                                                            decimalScale={2}
                                                            fixedDecimalScale={2}
                                                            value={String(uc.valor || 0).replace(".", ",")}
                                                            onValueChange={(values) => {
                                                                const valor = values.floatValue || 0;
                                                                atualizarValorUc(indiceMes, indiceUc, valor);
                                                            }}
                                                            style={{
                                                                minWidth: 90,
                                                                height: 28,
                                                                fontSize: "0.8rem",
                                                                textAlign: "right",
                                                                backgroundColor: uc.valor_preenchido_media ? "#EEE" : "#FFF",
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                                <Td fontSize="0.8rem">
                                                    {uc.importada_inicial ? null : (
                                                        <span>R$ {adicionarPontosMilhar(parseFloat(uc.media_historico_anos_anteriores || 0).toFixed(2))}</span>
                                                    )}
                                                </Td>
                                                <Td>
                                                    {uc.importada_inicial ? null : (
                                                        <Button
                                                            style={{ width: 120, padding: 2 }}
                                                            text={<span style={{ fontSize: "0.8rem" }}>Detalhar Cálculo</span>}
                                                            type="primary"
                                                            event={() =>
                                                                setDetalheCalculoMedia({
                                                                    ...uc,
                                                                    mes: mesPendente.mes,
                                                                })
                                                            }
                                                        />
                                                    )}
                                                </Td>
                                            </Tr>
                                        ))}
                                    </TBody>
                                </Table>
                            </div>
                        ))}
                    </div>
                </div>
            </ModalAlert>
            {detalheCalculoMedia && (
                <ModalAlert titulo={`Média do mês ${String(detalheCalculoMedia.mes).padStart(2, "0")}`} handleClose={() => setDetalheCalculoMedia(null)} maxWidth={520}>
                    <Table responsive maxHeight="360px">
                        <THead>
                            <Tr>
                                <Th>Ano</Th>
                                <Th alignRight>Valor</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {(detalheCalculoMedia.historico_anos_anteriores || []).map((itemHistorico) => (
                                <Tr key={`${itemHistorico.ano}-${itemHistorico.mes}`}>
                                    <Td>{itemHistorico.ano}</Td>
                                    <Td alignRight>R$ {adicionarPontosMilhar(parseFloat(itemHistorico.valor || 0).toFixed(2))}</Td>
                                </Tr>
                            ))}
                            <Tr>
                                <Td fontWeight={700}>Total</Td>
                                <Td alignRight fontWeight={700}>
                                    R$ {adicionarPontosMilhar(parseFloat(detalheCalculoMedia.media_historico_anos_anteriores || 0).toFixed(2))}
                                </Td>
                            </Tr>
                        </TBody>
                    </Table>
                </ModalAlert>
            )}
        </>
    );
}
